import { useEffect, useState } from 'react';

type OverflowTypes = 'visible' | 'hidden' | 'clip' | 'scroll' | 'auto';

export const useLockBodyScroll = (handler: boolean, forceOverflowReset?: OverflowTypes) => {
    const [originalOverflow, setOriginalOverflow] = useState('');

    useEffect(() => {
        if (!originalOverflow || originalOverflow === '') {
            setOriginalOverflow(window.getComputedStyle(document.body).overflow);
        }
        if (handler) {
            document.body.style.overflow = 'hidden';
        }
        return () => {
            if (forceOverflowReset) {
                document.body.style.overflow = forceOverflowReset;
            } else if (originalOverflow && originalOverflow !== '') {
                document.body.style.overflow = originalOverflow;
            } else {
                document.body.style.overflow = 'auto';
            }
        };
    }, [handler, forceOverflowReset, originalOverflow]);
};
